import React from 'react';
import '../styles/Contact.css';

const Contact: React.FC = () => {
  return (
    <div className="contact-container">
      <h1>Contact Us</h1>

      <div className="contact-sections">
        <div className="contact-section">
          <h2>CHINA</h2>
          <p><strong>Add:</strong> No.161 North Tongji Road, Tongan Xiamen P.C.361100</p>
          <p><strong>Tel:</strong> 0086-592-8983333</p>
          <p><strong>Fax:</strong> 0086-592-7559088</p>
          <p><strong>Email:</strong> <a href="mailto:info@flyingking.net">info@flyingking.net</a></p>
        </div>

        <div className="contact-section">
          <h2>USA</h2>
          <p><strong>Add:</strong> 14B Chestnut Ridge Road Montvale, NJ 07645</p>
          <p><strong>Tel/FAX:</strong> 001-201-722-1968</p>
          <p><strong>Contact:</strong> William</p>
          <p><strong>Email:</strong> <a href="mailto:william@glady.us">william@glady.us</a></p>

          <div className="sub-location">
            <p><strong>USA (New York)</strong></p>
            <p><strong>Add:</strong> 230 Grand St RM#602 NewYork, NY 10013</p>
            <p><strong>Fax:</strong> 001-212-226-2390</p>
            <p><strong>Contact:</strong> William</p>
          </div>
        </div>

        <div className="contact-section">
          <h2>GERMANY</h2>
          <p><strong>Add:</strong> Faehrstrasse 45, 21107 Hamburg</p>
          <p><strong>Tel:</strong> 0049-40-23846600</p>
          <p><strong>Fax:</strong> 0049-40-23846602</p>
          <p><strong>Contact:</strong> Lizhen Wang</p>
          <p><strong>Email:</strong> <a href="mailto:L.Wang@web.de">L.Wang@web.de</a></p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
